import React, { useState, useEffect } from "react";
import { apiService, API_ENDPOINTS } from "../../../services/apiService";

export const ChatModal = ({ isOpen, onClose, carId }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && carId) {
      fetchDocumentHistory();
    }
  }, [isOpen, carId]);

  const fetchDocumentHistory = async () => {
    try {
      setLoading(true);
      const response = await apiService.getDocumentHistory(carId);
      setHistory(response.data.history || []);
    } catch (err) {
      console.error("Error fetching document history:", err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="HistoryModal">
      <div className="modal-overlay">
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="model-header">
            <p>Document History</p>
            <button className="modal-close" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="model-body">
            <div className="chat-content">
              {loading ? (
                <p>Loading history...</p>
              ) : (
                <div className="history-list">
                  {history.map((item, index) => (
                    <div key={index} className="history-item">
                      <div className="history-action">{item.action}</div>
                      <div className="history-timestamp">
                        {new Date(
                          item.timestamp?.seconds * 1000
                        ).toLocaleString()}
                      </div>
                      {item.details && (
                        <div className="history-details">
                          {Object.entries(item.details).map(([key, value]) => (
                            <div key={key} className="detail-item">
                              <strong>{key}:</strong> {String(value)}
                            </div>
                          ))}
                          {item.details.imageUrls && (
                            <div className="history-images">
                              {item.details.imageUrls.map((img, imgIdx) => (
                                <img
                                  key={imgIdx}
                                  src={typeof img === 'string' ? img : img.url}
                                  alt={typeof img === 'string' ? '' : img.label || img.type || ''}
                                  className="history-image"
                                  style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'cover', borderRadius: '4px', margin: '4px' }}
                                  title={typeof img === 'string' ? '' : img.label || img.type || ''}
                                />
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
